export default {"src":"/_next/static/media/oven.273c2c4e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};